/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S5_I3Inputs */

const tr_kullanim_s5_i3 = /** @type {(inputs: Kullanim_S5_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yabancılık unsuru taşıyan uyuşmazlıklar MÖHUK çerçevesinde değerlendirilir.`)
};

const en_kullanim_s5_i3 = /** @type {(inputs: Kullanim_S5_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disputes containing a foreign element are assessed within the framework of MÖHUK.`)
};

const de_kullanim_s5_i3 = /** @type {(inputs: Kullanim_S5_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streitigkeiten mit Auslandsbezug werden im Rahmen des MÖHUK beurteilt.`)
};

const ru_kullanim_s5_i3 = /** @type {(inputs: Kullanim_S5_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Споры с иностранным элементом рассматриваются в рамках MÖHUK.`)
};

/**
* | output |
* | --- |
* | "Disputes containing a foreign element are assessed within the framework of MÖHUK." |
*
* @param {Kullanim_S5_I3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s5_i3 = /** @type {((inputs?: Kullanim_S5_I3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S5_I3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s5_i3(inputs)
	if (locale === "de") return de_kullanim_s5_i3(inputs)
	if (locale === "ru") return ru_kullanim_s5_i3(inputs)
	return tr_kullanim_s5_i3(inputs)
});